<ui-document class="file-document__card" [title]="file.name" [icon]="$any(fileIcon)">
  <ng-container ngProjectAs="[actions]">
    <span class="file-document__labels">
      <ng-content select="[labels]"></ng-content>
    </span>
    @if (canPreview) {
      <ui-tooltip [tooltipMessage]="'uploads.View_File' | translate" [tooltipPosition]="'below'">
        <ui-button variant="secondary" icon="Eye" [disabled]="busy" (clicked)="preview.emit(); $event.stopPropagation()"></ui-button>
      </ui-tooltip>
    }
    @if (canDownload) {
      <ui-tooltip [tooltipMessage]="'uploads.Download_File' | translate" [tooltipPosition]="'below'">
        <ui-button variant="secondary" icon="Download" [disabled]="busy" (clicked)="download.emit(); $event.stopPropagation()"></ui-button>
      </ui-tooltip>
    }
    @if (canRename) {
      <ui-tooltip [tooltipMessage]="'uploads.Rename_file' | translate" [tooltipPosition]="'below'">
        <ui-button
          variant="secondary"
          icon="Pencil"
          [disabled]="busy"
          (clicked)="renameRequested.emit(); $event.stopPropagation()"
        ></ui-button>
      </ui-tooltip>
    }
    @if (canInfo) {
      <ui-tooltip [tooltipMessage]="'aml.Details' | translate" [tooltipPosition]="'below'">
        <ui-button variant="secondary" icon="Info" [disabled]="busy" (clicked)="info.emit(); $event.stopPropagation()"></ui-button>
      </ui-tooltip>
    }
    @if (canDelete) {
      <ui-tooltip [tooltipMessage]="'uploads.Delete' | translate" [tooltipPosition]="'below'">
        <ui-button
          variant="secondary"
          icon="Trash2"
          [disabled]="busy"
          (clicked)="deleteRequested.emit(); $event.stopPropagation()"
        ></ui-button>
      </ui-tooltip>
    }
  </ng-container>
</ui-document>
